import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from "@material-ui/core/TableFooter";
import {TablePaginationActions} from "../table-pagination-actions/TablePaginationActions";
import TableLoader from 'components/ui/tables/rows/table-loader/TableLoader';
import PropTypes from "prop-types";
import {Tooltip} from "@material-ui/core";
import {Help} from "@material-ui/icons";

const useStyles = makeStyles({
    root: {
        width: '100%'
    },
    tableHeaders: {
        cursor: "default"
    }
});

function TableWithLabels(props) {
    const classes = useStyles();
    const handleChangePage = (event, newPage) => {
        props.fetchData(newPage, props.rowsPerPage);
    };

    const handleChangeRowsPerPage = (event) => {
        props.fetchData(0, +event.target.value);
    };

    return (
        <Paper className={classes.root}>
            <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow className={classes.tableHeaders}>
                            {props.headCells.map((column) => (
                                <TableCell
                                    key={"head-cell-" + column.id}
                                    align={column.align}
                                    style={{minWidth: column.minWidth, width: column.width}}
                                >
                                    {column.label}
                                    {column.tooltip ?
                                        <Tooltip title={column.tooltip}>
                                            <Help fontSize={"small"} color={"primary"}/>
                                        </Tooltip> : null
                                    }
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!props.loading ? props.tableRows :
                            <TableLoader loading={props.loading} colSpan={props.headCells.length}/>}
                    </TableBody>
                    {props.showPagination ?
                        <TableFooter>
                            <tr>
                                {props.count !== 0 ? <TablePagination
                                    rowsPerPageOptions={[5, 15, 25]}
                                    count={props.count}
                                    rowsPerPage={props.rowsPerPage}
                                    page={props.page}
                                    SelectProps={{
                                        inputProps: {'aria-label': 'rows per page'},
                                        native: true,
                                    }}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                /> : null}
                            </tr>
                        </TableFooter> : null}
                </Table>
            </TableContainer>

        </Paper>
    );
}

TableWithLabels.propTypes = {
    showPagination: PropTypes.bool,
    page: PropTypes.number,
    rowsPerPage: PropTypes.number,
    count: PropTypes.number,
    loading: PropTypes.bool,
    headCells: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        minWidth: PropTypes.number,
        width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        align: PropTypes.string,
        tooltipLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    })).isRequired
}

TableWithLabels.defaultProps = {
    showPagination: true
}

export default TableWithLabels;
